import React from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";

import CoreComponent20 from "../../../assets/Sub-component/CoreComponent20";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import Enterpertises2 from "../../../assets/Sub-component/Enterpertises2";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import cost from "../../../assets/Flutter/Scalable-solution/Costeffective.svg";
import deploy from "../../../assets/Flutter/Scalable-solution/Deployment.svg";
import solution from "../../../assets/Flutter/Scalable-solution/Solution.svg";
import culture from "../../../assets/Flutter/Scalable-solution/working culture.svg";
import expert_flutter from "../../../assets/Flutter/Scalable-solution/Specialised_fluter_app.svg";

import dynamic from "../../../assets/Services/Web_design/Offer_custamizable/Dynamic_web.svg";
import resposnsive from "../../../assets/Services/Web_design/Offer_custamizable/Responsive_web.svg";
import WebDesigns from "../../../assets/Services/Web_design/Offer_custamizable/Web_design.svg";

import cusotm from "../../../assets/Services/Web_design/Partner_with/custom_web.svg";
import ecom from "../../../assets/Services/Web_design/Partner_with/Ecom_web.svg";
import mobile from "../../../assets/Services/Web_design/Partner_with/mobile_app_design.svg";
import uiuxs from "../../../assets/Services/Web_design/Partner_with/UIUX.svg";
import webspeed from "../../../assets/Services/Web_design/Partner_with/Web_speed.svg";
import wordpress from "../../../assets/Services/Web_design/Partner_with/wordpress_web.svg";

import CoreComponent14 from "../../../assets/Sub-component/CoreComponent14";
import WebDesignCore from "../../../assets/Sub-component/WebDesignCore";
import { Link } from "react-router-dom";

import Concurrent from '../../../assets/Services/Java-dev/Line_section/Concurrent.svg'
import Convenient from '../../../assets/Services/Java-dev/Line_section/Convenient.svg'
import High_perf from '../../../assets/Services/Java-dev/Line_section/High-performance.svg'
import Platform_independent from '../../../assets/Services/Java-dev/Line_section/Platform_independent.svg'
import Secure from '../../../assets/Services/Java-dev/Line_section/Secure.svg'
import distributed from '../../../assets/Services/Java-dev/Line_section/distributed.svg'

import Custom_Java_Development from '../../../assets/Services/Java-dev/section/Custom_Java_Development.svg'
import J2EE_Development from '../../../assets/Services/Java-dev/section/J2EE_Development.svg'
import Java_Application_ from '../../../assets/Services/Java-dev/section/Java_Application_&_Maintenance.svg'
import Java_Mobile_Development from '../../../assets/Services/Java-dev/section/Java_Mobile_Development.svg'
import Java_Software_Development from '../../../assets/Services/Java-dev/section/Java_Software_Development.svg'
import Java_Web_Development from '../../../assets/Services/Java-dev/section/Java_Web_Development.svg'

import image from '../../../assets/Services/Java-dev/image.png'
import FaqHome from "../../../components/faq/FaqHome";
import launchingimage from '../../../assets/Launchingimage.png'
const JavaDevelopment = () => {
  const vertical = [
    {
      icon: Platform_independent,
      title: "Platform independent",
      line: "line-hori",
    },
    {
      icon: Secure,
      title: "Secure",
      line: "line-hori",
    },
    {
      icon: Convenient,
      title: "Convenient",
      line: "line-hori",
    },
    {
      icon: High_perf,
      title: "High performance",
      line: "line-hori",
    },
    {
      icon: Concurrent,
      title: "Concurrent",
      line: "line-hori",
    },

    {
      icon: distributed,
      title: "Distributed",
    },
  ];
  const content100 = [
    {
      icon: Custom_Java_Development,
      title: "Custom Java Development",
      desc: "We dedicate ourselves to building effective Java apps that support your particular business procedure and guarantee streamlined operations for your company.",
    },
    {
      icon: Java_Web_Development,
      title: "Java Web Development",
      desc: "From websites to intuitive web portals, we provide efficiency and security to our web applications by utilizing extensive frameworks for a dependable online presence.",
    },
    {
      icon: Java_Application_,
      title: "Java Application & Maintenance",
      desc: "We engage with you from the commencement and remain to deliver ongoing support, frequent updates, optimized solutions, and long-term stability.",
    },
    {
      icon: Java_Mobile_Development,
      title: "Java Mobile Development",
      desc: "Bringing Java's core strengths for mobile apps to create a meaningful space without any technical interruptions and providing a huge reach.",
    },
    {
      icon: J2EE_Development,
      title: "Java/J2EE Development",
      desc: "Java/J2EE built by our best Java developers ensures standardized integrated systems that relentlessly handle the complexities and data volumes.",
    },
    {
      icon: Java_Software_Development,
      title: "Java Software Development",
      desc: "We use accurate digital tools to create software that will work well in this cutthroat tech industry with maximum productivity and satisfaction.",
    },
  ];

  const content = [
    {
      icon: expert_flutter,
      title: "High-level Security",
      desc: "We use encryption in the development of our applications from the very beginning to the end. Raiden ensures that your data is safe from hackers and hacking websites and that it is free of bugs.",
      space: true,
    },
    {
      icon: cost,
      title: "Debugging Capability",
      desc: "Our best Java developers use contemporary tools to identify and resolve issues, guaranteeing that our software is efficient and reliable. This shortens repair times, increases user involvement, and decreases interruptions.",
      space: true,
    },
    {
      icon: solution,
      title: "Multiple APIs and Libraries",
      desc: "We are professionals at efficiently and conveniently developing complex applications. You can use our technology to connect to third-party services and current systems while adhering to best practices. ",
      space: false,
    },
    {
      icon: culture,
      title: "User-friendly",
      desc: "Our focus is to provide a well-established and clean structure, combined with Java's structured nature, for internal users. This approach enables us to offer customer-based solutions and reduce costs.",
      space: false,
    },
    {
      icon: deploy,
      title: "Faster and Efficient",
      desc: "Crafting a web structure with an efficient code base, effective usability, and utilizing eminent tools for further development. We optimize your resource utilization and yield a positive return on investment.",
      space: false,
    },
  ];

  return (
    <>
    <img 
  src={launchingimage} 
 className="Bg-image"
  alt="Launching"
/>

    <div className="main-page-wrapper">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />
      <div
        className=" container height-vh topheader-margin d-flex align-items-center justify-content-center flex-column "
       
      >
        <h1 className="fw-bold text-center h1-heading lh-sm">
          Java Development
        </h1>
        {/* <p className="fw-semibold mt-2  h1-para lh-base text-center ">
          {" "}
          code | dot | sjf | dsfs
        </p> */}
        <p className="text-center mt-4 mb-4 h1-para lh-base">
          Experience Raiden's 10 years of expertise in our commitment to
          providing an efficient website and maintaining it with 100%
          satisfaction for your business. Beyond the web, our Java expertise is
          useful in developing Android apps and critical IoT solutions.
        </p>
        <div className="d-flex ">
          <Link to="/request-quote">
            <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>

      <div className=" bg-light">
        <div className=" container pt-50 pb-50">
          <div className=" row mb-80 marb">
            <h2 className="col-lg-6  h2-heading lh-sm ">
              Java Application Development Services
            </h2>
            <p className="col-lg-6  h1-para lh-base" >
               Raiden's Java Application Development Service provides dependable, innovative solutions designed for the modern web. We successfully provide a variety of specialized services to our target market, which consists of businesses seeking web applications that are high-performing, scalable, and future-proof.
            </p>
          </div>

          <div>
            <CoreComponent20 content={content100} />
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className=" row">
          <div className="col-lg-6 text-center mb-3">
            <img src={image} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-sm">
              The Virtues of Java: Building Solid Applications
            </h2>
            <p className="mt-4  h1-para lh-base" >
              Raiden's Java application development service{" "}
              empowers your business by enhancing the foundation of operational
              efficiency across various systems and devices. Our methodologies
              keep aiding your sustainable performance, aligning with your
              business goals. Raiden's best Java developers architect various
              Java technologies and provide high-quality solutions to
              complexities that are not only technologically advanced but also
              economically viable. Java is the backbone for various companies in
              providing high traffic, security, and managing core processes. It
              saves significant development by eliminating the need for a
              particular team or separate codebases. Without shrinking any of
              these business possibilities, Raiden’s is committed to providing a
              well-developed Java application.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <WebDesignCore vertical={vertical} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="mb-4 text-center h2-heading lh-sm">
         Why Choose Java for Application Development

        </h2>
        <p className="mb-40 text-center mx-4 h1-para lh-base" >
Java is developing into more than just a programming language; it also designs and shapes your software environment in many ways.        </p>

        <CoreComponent14 content={content} />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="container text-center mt-80 mart">
        <h2 className="h2-heading lh-sm ">
         Mastering the Full Spectrum of Java Development
        </h2>
        <p className="my-3 h1-para lh-base">Excellence and Successful Execution</p>
        <Enterpertises2 />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default JavaDevelopment;
